// A short message floating above the bottom bar ("Added to your favourites"). It rises in, holds, then
// fades away; a new one replaces the last. With icon: "heart" it leads with a small filled heart.

const VISIBLE_MS = 1800
const ENTER = { duration: 420, easing: "cubic-bezier(0.16, 1, 0.3, 1)" }
const EXIT = { duration: 220, easing: "cubic-bezier(0.4, 0, 1, 1)" }

const ICONS = {
  heart: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-3.5 shrink-0 text-red-400" aria-hidden="true"><path d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" /></svg>',
  check: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="size-3.5 shrink-0 text-emerald-400" aria-hidden="true"><path d="m4.5 12.75 6 6 9-13.5" /></svg>'
}

let current = null

export function showToast(message, { icon } = {}) {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
  dismiss(current, reduceMotion, true)

  const toast = document.createElement("div")
  toast.setAttribute("role", "status")
  // Leave it out of Turbo's page snapshots, or going Back would bring it back for good
  toast.setAttribute("data-turbo-temporary", "")
  toast.className = "toast"
  if (icon && ICONS[icon]) toast.insertAdjacentHTML("beforeend", ICONS[icon])
  toast.append(document.createTextNode(message))
  document.body.appendChild(toast)
  current = toast

  if (!reduceMotion) {
    toast.animate([
      { opacity: 0, transform: "translateY(10px) scale(0.96)" },
      { opacity: 1, transform: "none" }
    ], ENTER)
  }

  toast.timer = setTimeout(() => dismiss(toast, reduceMotion), VISIBLE_MS)
}

function dismiss(toast, reduceMotion, replaced = false) {
  if (!toast || toast.leaving) return
  toast.leaving = true
  clearTimeout(toast.timer)
  if (current === toast) current = null

  if (reduceMotion) return toast.remove()

  // A toast being replaced gets out of the way quickly; one timing out drifts down as it fades
  const animation = toast.animate([
    { opacity: 1, transform: "none" },
    { opacity: 0, transform: replaced ? "scale(0.96)" : "translateY(4px)" }
  ], { ...EXIT, duration: replaced ? 120 : EXIT.duration, fill: "forwards" })
  animation.finished.then(() => toast.remove(), () => toast.remove())
}
